// NATIVE
import { useEffect, useState } from 'react';

// INSTALLED
import { Button, Divider } from '@mui/material';

// CUSTOM
import { mtDividerUpTable } from '../../commons';
import { hasPemissions } from '../../commons/utils';
import { TableAreas } from '../../components/tables/TableAreas';
import { DialogArea } from '../../components/modals/areas/DialogArea';
import { BreadCrumbsAndTitle } from '../../components/generics/BreadCrumbsAndTitle';
import { AlertsInformativos } from '../../components/generics/AlertsInformativos';
import { alertInformativo } from '../../commons/texts/textAlertsInformativos';
import { getSucursalesForSelect } from '../../store/sucursal';
import { useDispatch } from 'react-redux';

export const Areas = () => {
  // DISPATCH
  const dispatch = useDispatch();

  // USE STATE
  const [modalCreate, setModalCreate] = useState(false);
  const [canCreate, setCanCreate] = useState(false);

  // USE EFFECT
  useEffect(() => {
    hasPrmissionsCreate();
  }, []);

  // CONST FUNCTIONS
  const hasPrmissionsCreate = async () => {
    const hasPermissions = await hasPemissions('modulo.configuracion', 'modulo.areas', 'create');

    if (hasPermissions) {
      setCanCreate(true);
    }
  };

  // FUNCTIONS OPEN MODALS
  const openModal = async () => {
    await dispatch(getSucursalesForSelect());
    setModalCreate(true);
  };

  const handleCloseModalCrear = async () => {
    setModalCreate(false);
  };

  return (
    <div>
      <BreadCrumbsAndTitle
        title="Listado Areas"
        mainModule="configuracion"
        parent="Listado Areas"
        action=""
      />

      {canCreate && (
        <div style={{ display: 'flex', justifyContent: 'end' }}>
          <Button variant="contained" sx={{ marginBottom: 3 }} onClick={openModal}>
            Crear Area
          </Button>
        </div>
      )}

      <AlertsInformativos type={'info'} title={'info'} content={alertInformativo.area} />
      <Divider sx={{ marginBottom: mtDividerUpTable }} />
      <DialogArea open={modalCreate} handleCloseModalCrear={handleCloseModalCrear} />

      <TableAreas />
    </div>
  );
};
